import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/App/App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './assets/hooks/scrollToTop';

import "swiper/swiper-bundle.css";

import * as Sentry from "@sentry/browser";

const PRODUCTION_MODE = process.env.REACT_APP_MODE;
Sentry.init({ dsn: "https://e3aa6b51e3e44bfb8deba6ed2420ca71@sentry.cabahub.com/4", environment: PRODUCTION_MODE, });


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename={'/' + `${window.initialConstants.ROOT_PATH === '{{ROOT_PATH}}' ? '' : window.initialConstants.ROOT_PATH}`}>
      <ScrollToTop />
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
